import { type Theme, alpha, type SxProps } from '@mui/material';

export const getRowStyle = (
  theme: Theme,
  row: DeviceType,
  bulkMode: boolean,
  stagedInUse: Record<string | number, boolean>
): SxProps<Theme> => {
  if (bulkMode && row.id in stagedInUse) {
    const isEnabling = stagedInUse[row.id];
    return {
      backgroundColor: isEnabling
        ? alpha(theme.palette.primary.main, 0.12)
        : alpha(theme.palette.error.main, 0.12),
      borderLeft: `3px solid ${
        isEnabling ? theme.palette.success.main : theme.palette.error.main
      }`,
      '&:hover': {
        backgroundColor: isEnabling
          ? alpha(theme.palette.primary.main, 0.2)
          : alpha(theme.palette.error.main, 0.2),
      },
    };
  }
  return {};
};
